/** @format */
import { Context, createContext } from 'react';

import { Taxonomy } from '@toucan/client/global/taxonomy';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface TaxonomyContextProps {
    categories?: Taxonomy;
    brands?: Taxonomy;
}

export const TaxonomyContext: Context<TaxonomyContextProps> = createContext(
    {} as TaxonomyContextProps
);

TaxonomyContext.displayName = 'TaxonomyContext';
